// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Event/AddEventModal/index.css
// module id = 2459
// module chunks = 0